import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  useGetProductDocumentationQuery,
} from '../../redux-modules/service';
import { DocumentFileDownloadTable } from '../../components/DocumentFileDownloadTable';
import { Download } from '../../components/ui/icon/Download';
import { countTags } from '../../util/TagFilter';
import { TagFilterList } from '../../components/ui/view/TagFilterList';
import { ShowMoreLink } from '../../components/ui/view/ShowMoreLink';

function ProductDetailDocumentation({
  productId,
  loadingText,
}) {
  const {
    data,
    isFetching,
  } = useGetProductDocumentationQuery({ productId });
  const [limit, setLimit] = useState(3);
  const [categoryFilter, setCategoryFilter] = useState(null);
  const [documentForDownload, setDocumentForDownload] = useState(null);

  if (isFetching) {
    return (<div className="container">{loadingText}</div>);
  }

  const { total, translates } = data;
  const { product } = translates;
  let { documentation } = data;

  const categories = countTags(documentation, (item) => item.categories);

  if (categoryFilter) {
    documentation = documentation.filter(
      (document) => document.categories.indexOf(categoryFilter) !== -1,
    );
  }

  documentation = documentation.slice(0, limit);

  return (
    <div className="section-main">
      <div className="container">

        <div className="section-main-head">
          <div className="row align-item-center">
            <div className="col-12 col-lg">
              <h2>{Craft.t(product, 'Documentation')}</h2>
            </div>
          </div>
        </div>

        <TagFilterList
          tags={categories}
          totalCount={total}
          selectedTag={categoryFilter}
          onTagSelected={(tag) => setCategoryFilter(tag)}
        />

        <div className="popup-holder">
          <div className="main-modal rounded" id="modal-document-download">
            <div className="main-modal-close-head" />
            <div className="main-modal-content">
              <h2>{documentForDownload?.title}</h2>
              <p>{Craft.t(product, 'Select your desired language')}</p>

              {documentForDownload && (
                <DocumentFileDownloadTable
                  documentFiles={documentForDownload.files}
                  product={product}
                />
              )}
            </div>
          </div>
        </div>

        <div>
          {documentation.map((document) => (
            <a key={document.id} className="item-chock mb-3b main-modal-opener" href="#modal-document-download" onClick={() => setDocumentForDownload(document)}>
              <div className="item-frame">
                <h3>{document.title}</h3>
                {/* eslint-disable-next-line react/no-danger */}
                <div className="text-body" dangerouslySetInnerHTML={{ __html: document.description }} />
              </div>
              <div className="btn btn-tertiary">
                <Download />
                {Craft.t(product, 'Download')}
              </div>
            </a>
          ))}
        </div>
        {limit < total && (
          <ShowMoreLink label={Craft.t(product, 'Show all documents')} onClick={() => setLimit(total)} />
        )}
      </div>
    </div>
  );
}

ProductDetailDocumentation.propTypes = {
  productId: PropTypes.string.isRequired,
  loadingText: PropTypes.string.isRequired,
};

export { ProductDetailDocumentation };
